export class NostroChargesModel {
    product: string;
    currencyCode: string;
    partnerId: string;
    payingCurrency: string;
    charges: number;
    isEditable: boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/charges/NostroChargesModel.ts